// extracted by mini-css-extract-plugin
export var alignDiscLeft = "p_ql d_fl d_bC d_dr";
export var alignLeft = "p_p7 d_fl d_bC d_dr";
export var alignDiscCenter = "p_qm d_fm d_bz d_ds";
export var alignCenter = "p_bL d_fm d_bz d_ds";
export var alignDiscRight = "p_qn d_fn d_bD d_dt";
export var alignRight = "p_p8 d_fn d_bD d_dt";
export var footerContainer = "p_qp d_dS d_bS";
export var footerContainerFull = "p_qq d_dQ d_bS";
export var footerHeader = "p_kc d_kc";
export var footerTextWrapper = "p_qr d_s";
export var footerDisclaimerWrapper = "p_kk d_kk d_cg";
export var badgeWrapper = "p_qs d_s d_bw d_bL d_bB d_bF";
export var footerDisclaimerRight = "p_kl d_kl d_bw";
export var footerDisclaimerLeft = "p_km d_km d_bw";
export var verticalTop = "p_qt d_bw d_bF d_bK d_bH";
export var firstWide = "p_qv";
export var disclaimer = "p_qw";
export var socialDisclaimer = "p_qx";
export var left = "p_qy";
export var wide = "p_qz d_cv";
export var right = "p_qB d_bG";
export var line = "p_fg d_fh d_cr";
export var badgeDisclaimer = "p_qC d_by d_bL d_bF";
export var badgeContainer = "p_qD d_bw d_bD d_bL";
export var badge = "p_qF";
export var padding = "p_qG d_c4";
export var end = "p_qH d_bD";
export var linkWrapper = "p_qJ d_dx";
export var link = "p_mF d_dx";
export var colWrapper = "p_qK d_ct";
export var media = "p_qL d_bt d_dv";
export var itemRight = "p_qM";
export var itemLeft = "p_qN";
export var itemCenter = "p_qP";
export var exceptionWeight = "p_qQ s_rM";